// /Users/anandarajl/Desktop/my-app/src/redux/admin/userAccounts.slice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserAccounts,
  createUserAccount,
  updateUserCredentials,
  updateUserStatus,
} from "./userAccounts.thunk";

const initialState = {
  users: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedUser: null,
};

const userAccountsSlice = createSlice({
  name: "userAccounts",
  initialState,

  reducers: {
    setUserCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },

    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },
  },

  extraReducers: (builder) => {
    builder
      /* ================= FETCH USERS ================= */
      .addCase(fetchUserAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserAccounts.fulfilled, (state, action) => {
        state.loading = false;
        
        // ✅ Safely extract from either custom response wrapper structure or raw response
        const payloadData = action.payload?.data || action.payload;
        const payloadMeta = action.payload?.meta || action.payload;

        state.users = Array.isArray(payloadData) ? payloadData : [];
        state.totalPages = payloadMeta?.total_pages || 1;
        state.total = payloadMeta?.total || 0;
        state.limit = payloadMeta?.limit || 10;
      })
      .addCase(fetchUserAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.users = []; // Reset on hard tracking faults to prevent stale rows loop
      })

      /* ================= CREATE USER ================= */
      .addCase(createUserAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUserAccount.fulfilled, (state) => {
        state.loading = false;
        state.total += 1;
      })
      .addCase(createUserAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ================= UPDATE CREDENTIALS / PROFILE ================= */
      .addCase(updateUserCredentials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserCredentials.fulfilled, (state, action) => {
        state.loading = false;
        
        // Safely pull fields out of payload objects
        const userId = action.payload?.userId;
        const name = action.payload?.name;
        const email = action.payload?.email;

        if (userId) {
          const userIndex = state.users.findIndex((u) => u.user_id === userId);
          if (userIndex !== -1) {
            if (name) state.users[userIndex].name = name;
            if (email) state.users[userIndex].email = email;
          }

          if (state.selectedUser && state.selectedUser.user_id === userId) {
            if (name) state.selectedUser.name = name;
            if (email) state.selectedUser.email = email;
          }
        }
      })
      .addCase(updateUserCredentials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ================= UPDATE STATUS ================= */
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        if (!action.payload) return;
        const { id, is_active } = action.payload;

        const mappedUserRecord = state.users.find((u) => u.id === id);
        if (mappedUserRecord) {
          mappedUserRecord.is_active = is_active;
        }

        if (state.selectedUser && state.selectedUser.id === id) {
          state.selectedUser.is_active = is_active;
        }
      });
  },
});

export const {
  setUserCurrentPage,
  setSelectedUser,
  clearSelectedUser,
} = userAccountsSlice.actions;

export default userAccountsSlice.reducer;